import { provideAppInitializer, inject } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { UserModel } from '@app/shared/models/user.model';

export function restoreSessionInitializer(): Promise<UserModel | null> {
  const authService = inject(AuthService);
  return authService.restoreSession();
}

export const AppInitializerProvider = provideAppInitializer(restoreSessionInitializer);
